module.exports = __webpack_public_path__ + "static/media/safe.4e8e3400.svg";